// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getStatesInCountry} from '../../shared/repositories';

export const fetchStatesInCountry = query =>
    dispatch => {

        dispatch({
            type: actions.INCREASE_BUSY_COUNTER
        });

        return getStatesInCountry(query)
            .then(data => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

                dispatch({
                    data,
                    type: actions.READ_STATES_IN_COUNTRY_SUCCESS
                });

            })
            .catch(() => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

            });

    };



// WEBPACK FOOTER //
// ./src/product/status-change-request/action-creators/states-in-country.js